import { render, staticRenderFns } from "./TheGlobalProgress.vue?vue&type=template&id=0ef3d332"
import script from "./TheGlobalProgress.vue?vue&type=script&lang=ts"
export * from "./TheGlobalProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports